module.exports = require("./ca.d.ts");